import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiControllerService } from "src/app/shared/services/api-controller.service";
import { SettingService } from "src/app/shared/services/setting.service";

@Injectable({
   providedIn: 'root'
  })
  export class StoreSeatsService{

   constructor(private http: HttpClient, 
    private setting: SettingService,
  private apiController: ApiControllerService) { }

  verifySeat(storeId: string, section: string, row: string, seatNumber: string): Observable<boolean> {
    return Observable.create(o => {
      //this.http.post(this.setting.apiUrl('/StoreSeats/VerifySeat'), {
      this.apiController.post(this.setting.apiUrl('/StoreSeats/VerifySeat'), {
        storeId: storeId,
        section: section,
        row: row,
        seatNumber: seatNumber
      })
        .subscribe((valid: boolean) => {
          o.next(valid);
          o.complete();
        });
    })
  }
}
  